import { createContext, useContext, useState, useCallback } from "react";
import ar from "../Utils/Language/ar.json";
import en from "../Utils/Language/en.json";

const DICTIONARIES = { ar, en };

const LanguageContext = createContext(null);

const getInitial = () => {
    const stored = localStorage.getItem("language");
    if (stored === "en") return "en";
    return "ar"; // default Arabic
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(getInitial);

    const setLang = useCallback((newLang) => {
        localStorage.setItem("language", newLang);
        document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
        setLangState(newLang);
    }, []);

    const t = useCallback(
        (key) => DICTIONARIES[lang]?.[key] ?? DICTIONARIES["en"]?.[key] ?? key,
        [lang]
    );

    const dir = lang === "ar" ? "rtl" : "ltr";

    return (
        <LanguageContext.Provider value={{ lang, setLang, t, dir }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used inside <LanguageProvider>");
    return ctx;
};
